import { Dispatch } from 'redux';

import { FavoritePayload } from 'src/types';

import * as requestFromServer from './usersCrud';
import { userSlice, callTypes } from './usersSlice';

const { actions } = userSlice;

export const fetchUserLevelInfo = () => async (dispatch: Dispatch) => {
    dispatch(actions.startCall(callTypes.userInfoLoading));
    try {
        const response = await requestFromServer.getUserLevelInfo();
        dispatch(actions.saveUserLevelInfo(response.data));
    } catch (error) {
        dispatch(actions.catchError(error));
    }
};

export const fetchUserBaseInfo = () => async (dispatch: Dispatch) => {
    dispatch(actions.startCall(callTypes.userInfoLoading));
    try {
        const response = await requestFromServer.getUserBaseInfo();
        dispatch(actions.saveUserBaseInfo(response.data));
    } catch (error) {
        dispatch(actions.catchError({ error: error, key: callTypes.userInfoLoading }));
    }
};

export const createFavorite =
    (body: FavoritePayload, isLogin: boolean) => async (dispatch: Dispatch) => {
        dispatch(actions.startCall(callTypes.loading));
        try {
            dispatch(actions.favoriteCreated(body));
            if (isLogin) {
                await requestFromServer.createFavorite(body);
            }
        } catch (error) {
            dispatch(actions.catchError({ error: error, key: callTypes.loading }));
        }
    };
export const cancelFavorite =
    (body: FavoritePayload, isLogin: boolean) => async (dispatch: Dispatch) => {
        dispatch(actions.startCall(callTypes.loading));
        try {
            dispatch(actions.favoriteCanceled(body));
            if (isLogin) {
                await requestFromServer.cancelFavorite(body);
            }
        } catch (error) {
            dispatch(actions.catchError({ error: error, key: callTypes.loading }));
        }
    };

export const logout = () => async (dispatch: Dispatch) => {
    dispatch(actions.startCall(callTypes.loading));
    try {
        await requestFromServer.logout();
        dispatch(actions.logout());
    } catch (error) {
        dispatch(actions.catchError({ error: error, key: callTypes.loading }));
    }
};

export const getUserAssets = (body: object) => async (dispatch: Dispatch) => {
    try {
        const response = await requestFromServer.getUserAssets(body);
        dispatch(actions.userAssetsFetched(response.data));
    } catch (error) {
        dispatch(actions.catchError({ error: error, key: callTypes.loading }));
    }
};

export const refreshAuthToken = () => async (dispatch: Dispatch) => {
    try {
        const response = await requestFromServer.refreshAuthToken();
        // Added a 100ms delay to synchronize the c_token between cookies and the request, preventing any potential discrepancies.
        setTimeout(() => {
            dispatch(actions.tokenRefreshed(response.data.success));
        }, 100);
    } catch (error) {
        dispatch(actions.catchError({ error: error }));
    }
};

export const fetchUserVerifyInfo = () => async (dispatch: Dispatch) => {
    dispatch(actions.startCall(callTypes.loading));
    try {
        const response = await requestFromServer.getUserVerifyInfo();
        dispatch(actions.saveUserVerifyInfo(response.data));
    } catch (error) {
        dispatch(actions.catchError({ error: error, key: callTypes.loading }));
    }
};

export const getUserInviteCode = () => async (dispatch: Dispatch) => {
    dispatch(actions.startCall(callTypes.loading));
    try {
        const response = await requestFromServer.getUserInviteCode();
        dispatch(actions.saveUserInviteCode(response.data));
    } catch (error) {
        dispatch(actions.catchError({ error: error, key: callTypes.loading }));
    }
};

export const openFutures = () => async (dispatch: Dispatch) => {
    dispatch(actions.startCall(callTypes.openFuturesLoading));
    try {
        const response = await requestFromServer.openFutures();
        dispatch(actions.saveOpenFutures(response.data));
    } catch (error) {
        dispatch(actions.catchError({ error: error, key: callTypes.openFuturesLoading }));
    }
};
